<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-epigraph element-without-heading" epub:type="epigraph" id="epigraph" role="doc-epigraph">
<div class="text" id="epigraph-text">
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center epigraph-content"><i>Deception comes in many forms.</i></p>
<p class="alignment-block-content alignment-block-content-center epigraph-content"><i>It’s even more destructive when delivered by a familiar hand.</i></p>
<p class="alignment-block-content alignment-block-content-center epigraph-content"><i>— Descent into Deceit</i></p>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?4620dad2